import { createApp } from 'vue'
import App from './components/App.vue'

const app = createApp( App );

if( document.querySelector( '#calculator' ) ) {

    app.mount( '#calculator' );

}